import {SlButton, SlDialog} from '../../../../../../clxFrontendCms/public/js/shoelace/shoelace';

export default class OpenLayer {

    constructor() {
         this.initEventListeners();
    }

    private initEventListeners() {
        const container = document.querySelector('.basket-vvl-restlaufzeit');
        if(!container) {
            return;
        }
        const openButton = container.querySelector('.open-basket-vvl-restlaufzeit-layer') as SlButton;
        if(!openButton) {
            return;
        }
        const dialog = container.querySelector('.basket-vvl-restlaufzeit-layer') as SlDialog;
        if(!dialog) {
            return;
        }

        openButton.addEventListener('click', function(ev) {
            dialog.show();
            ev.preventDefault();
        });
        const closeButton = document.querySelector('.basket-vvl-restlaufzeit-layer .closeVVLLayer');
        if(!closeButton) {
            return;
        }
        closeButton.addEventListener('click', function(ev) {
            dialog.hide();
            ev.preventDefault();
        });

    }
}
